// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_FIREBASE_APP_ID
// };

// export const firebaseApp = initializeApp(firebaseConfig);

// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyBARiWALkR02SelUsr4G6QZ9grLMHu44UI",
//   authDomain: "ajbike-3c68d.firebaseapp.com",
//   projectId: "ajbike-3c68d",
//   storageBucket: "ajbike-3c68d.firebasestorage.app",
//   messagingSenderId: "820719574",
//   appId: "1:820719574:web:2a9681f1162897220dfe77",
//   measurementId: "G-8T37XD2D0L"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
// export { firebaseApp };


// src/firebase.js

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBARiWALkR02SelUsr4G6QZ9grLMHu44UI",
  authDomain: "ajbike-3c68d.firebaseapp.com",
  projectId: "ajbike-3c68d",
  storageBucket: "ajbike-3c68d.firebasestorage.app",
  messagingSenderId: "820719574",
  appId: "1:820719574:web:2a9681f1162897220dfe77",
  measurementId: "G-8T37XD2D0L",
};

// ✅ Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// ✅ Optional analytics
const analytics = getAnalytics(firebaseApp);

// ✅ Auth instance export (for login/signup)
export const auth = getAuth(firebaseApp);

// ✅ Export app + analytics (if needed)
export { firebaseApp, analytics };
